/**
 * Returns the language by the given isoCode.
 *
 * @return {string|null}
 * @param isoCode
 */
export function languageByIsoCode(isoCode) {
  switch (isoCode) {
    case 'de':
      return "Allemand";
    case 'fr':
      return "Français";
    case 'en':
      return "Anglais";
    case 'lb':
      return "Luxembourgish";
    default:
      return isoCode;
  }
}

export function mapDayFromEnglishToFrench(day) {
  day = day.toLowerCase();
  switch (day) {
    case "monday":
      return "Lundi";
    case "tuesday":
      return "Mardi";
    case "wednesday":
      return "Mercredi";
    case "thursday":
      return "Jeudi";
    case "friday":
      return "Vendredi";
    case "saturday":
      return "Samedi";
    case "sunday":
      return "Dimanche";
  }
}

export function mapEnglishDayToNumber(day) {
  day = day.toLowerCase();
  switch (day) {
    case "monday":
      return 1;
    case "tuesday":
      return 2;
    case "wednesday":
      return 3;
    case "thursday":
      return 4;
    case "friday":
      return 5;
    case "saturday":
      return 6;
    case "sunday":
      return 7;
  }
}

export function mapDayOfWeekFromNumber(day) {
  switch (day) {
    case 1:
      return {fr: "Lundi", en: "Monday"};
    case 2:
      return {fr: "Mardi", en: "Tuesday"};
    case 3:
      return {fr: "Mercredi", en: "Wednesday"};
    case 4:
      return {fr: "Jeudi", en: "Thursday"};
    case 5:
      return {fr: "Vendredi", en: "Friday"};
    case 6:
      return {fr: "Samedi", en: "Saturday"};
    case 7:
      return {fr: "Dimanche", en: "Sunday"};
  }
}
